// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { requisitionsHeaderStyles } from "@insite/content-library/Widgets/Requisitions/RequisitionsHeader";
import { css } from "styled-components";

requisitionsHeaderStyles.titleText = {
    variant: "h3",
    css: css`
        margin-bottom: 30px;
        @media print {
            font-size: 11px;
        }
    `,
};
